import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { Button, ButtonType } from '@junglescout/edna'

import { mountWistia } from 'services/wistia'
import { showAccountSyncModal } from 'actions/account/sellerAccountSync'
import { AMAZON_SELLER_KEYS_SYNC_STEPS } from 'constants/account'

const VideoFrame = styled.div`
  width: 900px;
  opacity: 0.99;
  border-radius: 2px;
  background-color: ${props => props.theme.colors.grey100};
  padding: 15px;
  border: 1px solid ${props => props.theme.colors.grey300};
  margin-top: 20px;
  margin-bottom: 20px;
`
const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
`

const TutorialStep = ({ className, previousModal }) => {
  const { t } = useTranslation(['generic, mwsSync'])
  const dispatch = useDispatch()

  useEffect(() => {
    mountWistia()
  }, [])

  const renderVideo = video => (
    <div
      className="wistia_responsive_padding"
      style={{
        padding: '62.5% 0 0 0',
        position: 'relative',
        width: '100%',
        height: '100%'
      }}>
      <div
        className="wistia_responsive_wrapper"
        style={{
          height: '100%',
          left: '0',
          position: 'absolute',
          top: '0',
          width: '100%'
        }}>
        <div
          className={`wistia_embed wistia_async_${video} videoFoam=true autoPlay=true`}
          style={{ height: '100%', width: '100%' }}
        />
      </div>
    </div>
  )

  const handleBackButtonClick = () =>
    dispatch(showAccountSyncModal(AMAZON_SELLER_KEYS_SYNC_STEPS[previousModal]))

  return (
    <div className={className}>
      <VideoFrame>{renderVideo('g3n1uujdgl')}</VideoFrame>
      <Footer>
        <Button btnType={ButtonType.TERTIARY} onClick={handleBackButtonClick}>
          {t('generic:Back', 'Back')}
        </Button>
      </Footer>
    </div>
  )
}

TutorialStep.propsTypes = {
  previousModal: PropTypes.string
}

export { TutorialStep }
